import * as React from "react";

import './RegisteredStatusBox.pcss';

export const RegisteredStatusBox = () =>
  <div className={"registered-status-box"}>
    <span className="material-icons">check_circle</span>
    <span className={"text"}>Registered</span>
  </div>
;
